import { default as SvgIcon, SvgIconProps } from '@mui/material/SvgIcon';

const FilledWarningIcon = (props: SvgIconProps) => {
  const {
    xmlns = 'http://www.w3.org/2000/svg',
    width = '24',
    height = '24',
    fill = 'currentColor',
    className = 'mi-solid mi-alert',
    viewBox = '0 0 24 24',
    ...rest
  } = props;
  return (
    <SvgIcon
      xmlns={xmlns}
      width={width}
      height={height}
      fill={fill}
      className={className}
      viewBox={viewBox}
      {...rest}
    >
      <path d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.06 16.15C13.06 16.7 12.61 17.15 12.06 17.15C11.51 17.15 11.06 16.7 11.06 16.15V12.01C11.06 11.46 11.51 11.01 12.06 11.01C12.61 11.01 13.06 11.46 13.06 12.01V16.15ZM12.06 9.04C11.51 9.04 11.06 8.59 11.06 8.04C11.06 7.49 11.51 7.04 12.06 7.04C12.61 7.04 13.06 7.49 13.06 8.04C13.06 8.59 12.61 9.04 12.06 9.04Z' />
    </SvgIcon>
  );
};

export default FilledWarningIcon;
